// Vídeos do site (loop do topo e trailer). NÃO vão para o git: vivem no servidor, em MEDIA_DIR, e servem-se em
// /media/<ficheiro> (apps/backend/src/static.ts). Enviar com deploy/cax/upload-media.ps1. Sem dependências.
export const MEDIA_PREFIX = "/media/";

/** Ficheiros permitidos (lista fechada: o backend só serve estes nomes). */
export const MEDIA_FILES = {
  heroWebm: "ecliptica-hero-loop.webm",
  heroMp4: "ecliptica-hero-loop.mp4",
  trailer: "ecliptica-trailer-v2.mp4",
} as const;

export const mediaUrl = (file: string) => MEDIA_PREFIX + file;

const TYPES: Record<string, string> = { webm: "video/webm", mp4: "video/mp4" };

/** Nome do ficheiro pedido em /media/<nome> (só os da lista) e o tipo MIME; null se não for um deles. */
export function mediaFile(path: string): { name: string; type: string } | null {
  if (!path.startsWith(MEDIA_PREFIX)) return null;
  const name = path.slice(MEDIA_PREFIX.length);
  if (!(Object.values(MEDIA_FILES) as string[]).includes(name)) return null;
  return { name, type: TYPES[name.split(".").pop() ?? ""] ?? "application/octet-stream" };
}
